type SelectionContextMetaItem = {
  label: string;
  value?: string | null;
};

type SelectionContextMetaProps = {
  items: SelectionContextMetaItem[];
};

export function SelectionContextMeta({ items }: SelectionContextMetaProps) {
  const visible = items.filter((item) => item.value);

  if (visible.length === 0) {
    return null;
  }

  return (
    <dl className="erp-context-meta">
      {visible.map((item) => (
        <div key={item.label} className="erp-context-meta-item">
          <dt>{item.label}</dt>
          <dd>{item.value}</dd>
        </div>
      ))}
    </dl>
  );
}
